import React from 'react';
import './style.css'; // Make sure this is the correct path to your CSS file

export const Popup = ({ isVisible, onClose, onContinue, setInputValue1, setInputValue2, inputValues }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="popup">
      <div className="popup-inner">
        <div className="popup-header-container">
          <div className="popup-header">Anpassung des Hauptcharakters</div>
          <span className="popup-label">Wenn Sie das nicht möchten, drücken Sie einfach auf Schließen.</span>
          <button className="close-btn" onClick={onClose}>Schließen</button>
        </div>
        <label htmlFor="input1">Name:</label>
        <input
          id="input1"
          type="text"
          placeholder="Max Mustermann"
          value={inputValues.value1}
          onChange={(e) => setInputValue1(e.target.value)}
        />

        <label htmlFor="input2">Interessen und weiter Informationen:</label>
        <input
          id="input2"
          type="text"
          placeholder="schlau, schnell und gut im Lego bauen..."
          value={inputValues.value2}
          onChange={(e) => setInputValue2(e.target.value)}
        />

        <button onClick={onContinue}>Anpassen</button>
      </div>
    </div>
  );
};